
define('known/views/productLeaguesView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/productModel',
	'known/collections/leagueInstanceCollection',
	'known/models/userModel',
	
	//Templates
	'text!known/templates/lgListContainerTemplate.html',
	'text!known/templates/lgListStatusTemplate.html',
	'text!known/templates/lgListItemTemplate.html',
	
	//Shims
	'jquery.collapsible'
], function($, _, Backbone, ProductModel, LeagueInstanceCollection, UserModel, containerHtml, statusHtml, itemHtml){
	var LeagueListingDelContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			this.league = options.league;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'submitDeleteLeagueForm');
			
			this.listenTo(this.event, 'save', this.deleteLeague);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.deleteLgForm);
			this.listenTo(this.event, 'success', this.deleteLgForm);
			
			$(this.el).find(".lgListingDeleteConfirm").on('click', this.submitDeleteLeagueForm);
		},
		
		deleteLeague: function(event) {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;				
				this.league.destroy({success: this.successCallback, error: this.errorCallback, wait: true});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		submitDeleteLeagueForm: function () {
			this.event.trigger("save");
		},
		
		hideAll: function() {
			$(this.el).hide();
		},
		
		deleteLgForm: function () {
			this.hideAll();
			$(this.el).show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var LeagueListingDelMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.remSuccess);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$(".lgListingDeleteMessageError").hide();
			this.$(".lgListingDeleteMessageProcessing").hide();
			this.$(".lgListingDeleteMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".lgListingDeleteMessageError").show();
		},
		
		remSuccess: function () {
			this.hideAll();
			//$(this.el).show();
			//this.$(".lgListingDeleteMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".lgListingDeleteMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var LeagueListingView = Backbone.View.extend({
		initialize: function(options) {
			this.userModel = options.userModel;
			this.league = options.league;
			this.product = options.product;
			this.template = _.template(itemHtml.trim());
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			
			this.updateVisuals();
			
			this.message = new LeagueListingDelMessageView({el: this.$(".lgListingDeleteMessage"), event: this.event});
			this.content = new LeagueListingDelContentView({
				el: this.$(".lgListingDelete"), 
				event: this.event,
				submittedData : this.submittedData,
				league: this.league});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			//Setup Form open/hide
			var delLgOpenBtn = this.$(".lgListingDeleteOpen");
			var delLgCloseBtn = this.$(".lgListingDeleteCancel");
			
			delLgOpenBtn.on('click', {}, this.showView);
			delLgCloseBtn.on('click', {}, this.hideView);
		},
		
		render: function () {
			this.event.trigger("default");
			
			return this;
		},
		
		updateVisuals: function () {
			
			var draftAvailable = '';
			if(this.league.get('draftStatus') == 'SETUP'){
				draftAvailable = 'hide hidden';
			}
			
			this.setElement($(this.template({
				lgDispName: this.league.prettyDispName(),
				lgId: this.league.get("leagueId"),
				lgInstId: this.league.get("id"),
				draftAvailable: draftAvailable
			})));
			
			if(this.league.get('owner')){
				$(this.el).find('.lgListingDeleteOpen').show();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$(".lgListingDeleteOpen").show();
			this.$(".lgListingDelete").hide();
		},
		
		showView: function() {
			this.$(".lgListingDeleteOpen").hide();
			this.$(".lgListingDelete").show();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				this.league.destroy();
				
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function () {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}

			this.$(".lgListingDeleteOpen").show();
			this.$(".lgListingDelete").hide();
		},
	    
	    destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        },
		
		close:function () {
	        this.$el.remove();
	    }
	});
	
	var LeagueStatusView = Backbone.View.extend({
		initialize: function(options) {
			this.userModel = options.userModel;
			this.lgList = options.lgList;
			this.product = options.product;
			this.status = options.status;
			this.template = _.template(statusHtml.trim());
			
			this.lgListingViews = [];
			
			this.size = _.size(this.lgList);
			
			//this.listenTo(this.leagueCollection, 'remove', this.render);
		},
		
		render: function () {
			var prodLgName = this.product.get('sport');
			var prodYear = this.product.get('year');
			
			var productTitle = prodLgName.toUpperCase() + " " + prodYear;
			
			var statusTitle = "";
			var productWrapperId = prodLgName.toLowerCase() + prodYear;			
			var statusDescription = "";
			
			switch (this.status) {
			case "STARTED":
				statusTitle = "Drafts Started";
				statusDescription = "started leagues";
				productWrapperId += "Started";
				break;
			case "SETUP":
				statusTitle = "Drafts in Setup";
				statusDescription = "leagues in setup";
				productWrapperId += "Setup";
				break;
			case "COMPLETED":
				statusTitle = "Completed Drafts";
				statusDescription = "completed leagues";
				productWrapperId += "Completed";
				break;
			default:
				break;
			}
			
			productWrapperId += "Wrapper";
			
			this.el = $(this.template({
				statusTitle: statusTitle,
				productWrapperId: productWrapperId,
				productTitle: productTitle,
				statusDescription: statusDescription
			}));
			
			this.addAll();
			
			$(this.el).find('.prodCollapseBtn').on('click', {el: $(this.el).find('#' + productWrapperId)}, function (event) {
				event.data.el.collapse('toggle');
			});
			
			return this;
		},
		
		addLeague: function(league) {
			var view = new LeagueListingView({userModel: this.userModel, league: league, product: this.product});
			$(this.el).find(".lgListingCollapsible").append(view.render().el);
			this.lgListingViews[league.cid] = view;
			this.listenTo(league, 'destroy', this.removeLeague);
		},
		
		addAll: function() {
			if(this.size > 0){
				_.each(this.lgList, function(league){
					this.addLeague(league);
				}, this);
			} else {
				$(this.el).find('.lgListingNotAvailable').removeClass('hidden');
			}
		},
		
		removeLeague: function(league) {
			this.stopListening(league, 'destroy', this.removeLeague);
			this.lgListingViews[league.cid].destroyView();
			delete this.lgListingViews[league.cid];
			
			this.size = this.size-1;
			
			if(this.size == 0){
				$(this.el).find('.lgListingNotAvailable').removeClass('hidden');
			}
		},
		
		/*removeAll: function() {
			_.each(this.lgListingViews, function(view, key){
				this.lgListingViews[key].close();
				delete this.lgListingViews[key];
			}, this);
		},
		
		close:function () {
			this.removeAll();
	        this.$el.remove();
	    }*/
	});
	
	var ProductLeaguesView = Backbone.View.extend({
		initialize: function(options) {
			this.product = options.product;
			this.leagueCollection = options.leagueCollection;
			this.userModel = options.userModel;
			
			this.template = _.template(containerHtml.trim());
			
			this.lgStatusViews = [];
		},
		
		render: function () {
			//this.removeAll();
			
			var productTitle = this.product.get('sport').toUpperCase() + " " + this.product.get('year');
			
			this.el = $(this.template({
				productTitle: productTitle,
				product: this.product.get('sport').toUpperCase()
			}));
			
			this.addAll(this.el);
			
			return this;
		},
		
		addLgStatus: function(lgList, status, el) {
			var view = new LeagueStatusView({userModel: this.userModel, lgList: lgList, product: this.product, status: status});
			el.children(".row-fluid").append(view.render().el);
			this.lgStatusViews[status] = view;
		},
		
		addAll: function(el) {
			var prodLgs = this.leagueCollection.leaguesForYearSport(this.product.get('year'), this.product.get('sport').toUpperCase());
			
			var startedLgs = _.sortBy(_.filter(prodLgs, function(league) {
				return league.get('draftStatus') == 'STARTED' || league.get('draftStatus') == 'PREDRAFT';
			}, this),
			function(league){ return league.get("displayName"); }, this);
			
			this.addLgStatus(startedLgs, "STARTED", el);
			
			var setupLgs = _.sortBy(_.filter(prodLgs, function(league) {
				return league.get('draftStatus') == 'SETUP';
			}, this),
			function(league){ return league.get("displayName"); }, this);
			
			this.addLgStatus(setupLgs, "SETUP", el);
			
			var completedLgs = _.sortBy(_.filter(prodLgs, function(league) {
				return league.get('draftStatus') == 'COMPLETED';
			}, this),
			function(league){ return league.get("displayName"); }, this);
			
			this.addLgStatus(completedLgs, "COMPLETED", el);
		},
		
		/*removeAll: function() {
			_.each(this.lgStatusViews, function(view, key){
				this.lgStatusViews[key].close();
				delete this.lgStatusViews[key];
			}, this);
		}*/
	});
	
	return ProductLeaguesView;  
});